<template>
  <nav class="NavBar d-flex flex-row bg-white">
    <div class="NavBar__logo d-flex align-items-center">
      <router-link :to="{ name: 'home' }">
        <Logo :company="company" />
      </router-link>
    </div>
    
    <b-nav pills class="d-flex justify-content-start flex-grow-1 text-right align-self-center mx-3 px-3">
      <b-nav-item :to="{ name: 'introduction' }" active-class="active">
        <FontAwesomeIcon :icon="['fas', 'info-circle']" size="lg" class="mr-2" /> Introductie
      </b-nav-item>
      <b-nav-item :to="{ name: 'filters' }" active-class="active">
        <FontAwesomeIcon :icon="['fal', 'barcode-alt']" size="lg" class="mr-2" /> Barcode Selectie
      </b-nav-item>
      <b-nav-item :to="{ name: 'home' }" exact-active-class="active">
        <FontAwesomeIcon :icon="['fal', 'map']" size="lg" class="mr-2" /> Kaart
      </b-nav-item>
      <b-nav-item :to="{ name: 'neighborhood-information' }" active-class="active">
        <FontAwesomeIcon :icon="['fal', 'file-chart-line']" size="lg" class="mr-2" /> Buurt informatie
      </b-nav-item>

      <!-- <b-nav-item :to="{ name: 'barcodes' }" active-class="active">
        <FontAwesomeIcon :icon="['fal', 'barcode-alt']" size="lg" class="mr-2" /> Barcodes
      </b-nav-item> -->
      <!-- <b-nav-item :to="{ name: 'print' }" active-class="active">
        <FontAwesomeIcon :icon="['fal', 'file-pdf']" size="lg" class="mr-2" /> Afdrukken
      </b-nav-item> -->
    </b-nav>
    
  </nav>
</template>

<script>
import { image } from 'helper/assets'
import Logo from 'atom/branding/Logo'

export default {
  name: 'NavBar',
  components: {
    Logo
  },
  data() {
    return {
      company: 'Platform31'
    }
  },
  methods: {
    image
  }
}
</script>

<style lang="scss">
.NavBar {
  height: 70px;
  min-height: 70px;
  // background: #081736; // white;
  box-shadow: 0px -1px 0px 0px rgba(223,226,229,1) inset;
  user-select: none;

  &__logo {
    width: 250px;
    height: 100%;
    padding: 7px;
  }
  &__description {
    // color: white;
    text-transform: uppercase;
    // padding-top: 0.6rem;
  }
  .form-group {
    margin-bottom: 0
  }
}
</style>
